//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {downloadFile ,getTime} from '@/assets/js/tool';
import {getworkOrderType} from "@/assets/js/dict";
export default({
    props:['fileLength','id'],
    created(){
        getworkOrderType().then(res=>{
            this.workOrderList=res
        })
    },
    data(){
        return {
            pickerOptions: {
                disabledDate(time) {
                return time.getTime() < Date.now();
                },
            },
           postilVisible:false,
           childrenList:[],
           loading:false,
           fileVisible:false,
           headers:{},
           traProjectFileList:[],
           obj:'',
           fileName:'',
           info:'',
           workVisible:false,
           fileNames:'',
           fileUrls:'',
           fileDialog:false,
           workOrderList:[],
           editDialog:false,
           editForm:{  //申请编辑
            finalProjectInvestment:'',
            finalProjectContent:'',
            finalProjectCraft:'',
            finalProjectDuration:'',
            originProjectContent: '',
            originProjectCraft: '',
            originProjectDuration: '',
            originProjectInvestment: '',
            originProjectPlanEndTime: '',
            traProjectId:''
           },
           extendVisible:false,
           formbz:{
            applyReason:'',
            addDay:'', //延长天数
            applyType:'0',
            newTime:'',
            oldTime:'',
            traProjectId:''
           },
           form:{  //添加工单
                demandDescribe:'',
                demandType:'',
                relationType:9, //关联类型 项目
                traProjectId:'',
                newMeetingPlace:'',
                newMeetingTime:'',
                oldMeetingPlace:'',
                oldMeetingTime:'',
                projectName:'',
           },
           auditVisible:false, //审核动态
           formz:{  //审核动态
                projectCode:'',
                projectName:'',
                examineDetail:'',
                traProjectId:''
           },
           refundVisible:false,
           refundForm:{  //申请退款
                traProjectBidIds:'',
                refundMoney:0,
                refundDescribe:'',
                traProjectId:''
            },
            personList:[], //退款人员列表
            recordVisible:false,
            recordList:[],
            reForm:{
                traProjectWorkFileId:'',
                pageIndex:1,
                pageSize:10,
            },
           rules: {
                finalProjectInvestment:{
                    required: true,
                    message: '请输入拟定投资额',
                    trigger: 'blur'
                },
                finalProjectContent:{
                    required: true,
                    message: '请输入项目建设详情',
                    trigger: 'blur'
                },
                demandType:{
                    required: true,
                    message: '请选择需求类型',
                    trigger: 'change'
                },
                demandDescribe:{
                    required: true,
                    message: '请填写需求描述',
                    trigger: 'blur'
                },
                newMeetingTime:{
                    required: true,
                    message: '请选择评估会时间',
                    trigger: 'change'
                },
                newMeetingPlace:{
                    required: true,
                    message: '请填写评估会地点',
                    trigger: 'blur'
                },
                traProjectBidIds:{
                    required: true,
                    message: '请选择退款人员',
                    trigger: 'change'
                },
                refundDescribe:{
                    required: true,
                    message: '请填写退款申请描述',
                    trigger: 'blur'
                }
            },
        }
    },
    methods:{

        //申请编辑
        openEdit(){
            this.editForm.finalProjectInvestment = ''
            this.editForm.finalProjectContent = ''
            this.editForm.finalProjectCraft = ''
            this.editForm.finalProjectDuration =''
            this.editForm.originProjectContent = '';
            this.editForm.originProjectCraft = '';
            this.editForm.originProjectDuration = '';
            this.editForm.originProjectInvestment = '';
            this.editForm.originProjectPlanEndTime = '';
            this.getProInfo()
            this.editDialog= true
        },  

        // 确定编辑
        ensureEdit(form){
            this.editForm.traProjectId =this.$route.query.id;
            this.$refs[form].validate((valid) => {
                if (valid) {
                    this.$put('/tra/project/modify/edit', this.editForm, function(res){
                        if (res.code == 200) {
                            this.$message.success('提交成功!');
                            this.editDialog = false;
                            this.$parent.projectXn(); //协作
                            this.$parent.applyInfo(); //申请编辑列表
                        }else{
                            this.$message.error(res.msg);
                        }
                    },true)
                }
            })
        },

        // 申请延长服务保障期
        extension(){
            this.extendVisible= true
        },
        //确定延长
        ensureExtend(){
            var formbz= JSON.parse(JSON.stringify(this.formbz));
            if(formbz.addDay==''){
                this.$message.error('请填写延长天数');
                return
            }
            var oldTime= new Date(formbz.oldTime).getTime();
            var newTime = oldTime+formbz.addDay*24*60*60*1000;
            formbz.newTime= getTime(newTime);
            formbz.traProjectId= this.$route.query.id
            this.$post('/tra/project/ensure/extend', formbz,function(res){
                if (res.code == 200) {
                this.$message.success('操作成功!')
                this.extendVisible= false;
                this.$parent.projectXn();
                this.$parent.projectDetail();
                this.$parent.extendInfo()
                }
            },true)
        },

         // 下载资料
        downloadUrl(fileUrl,fileName){
            downloadFile(fileUrl,fileName)
        },
        //批注列表
        lookAudit(id,workId){
            this.postilVisible=true
            this.$get('/tra/project/work/file/list?fileType=2&parentId=' + id + '&traProjectWorkId=' + workId,function(res){
                if(res.code==200){
                    this.childrenList= res.data
                }
            })
        },
        // 查看文字批注
        lookPositl(positl,typezz) {
            if (!positl) {
                this.$message.error('未提交文字批注');
                return
            }
            var title='';
            if(typezz==1){
                typezz='文件文字'
            }else{
                typezz='批注内容'
            }
            this.$alert(positl, typezz, {
                showConfirmButton: false
            });
        },

        onProgress(){
            this.loading= true
        },

        fileuploads(){
            this.fileDialog= true
            this.fileNames= ''
            this.fileUrls=''
        },
        //编制项目前期所需文件
        fileSuccess(res){
            this.fileUrls = res.data.fileUrl;
            this.fileNames = res.data.fileName;
            this.loading = false
        },

        filesUpload(file){
            const isLt1G = file.size / 1024 / 1024 / 1024 < 1;
            if (!isLt1G) {
                this.$message.error('上传文件大小不能超过 1GB!');
            }
            const changdu = file.name.length<50;
            if (!changdu) {
                this.$message.error('文件名称过长,请限制在25字之内!');
            }
            return isLt1G&&changdu;
        },

        // 上传编制前期资料确定
        submitFiles(){
            var obj={
                fileName:this.fileNames,
                fileUrl:this.fileUrls,
                traProjectId:this.$route.query.id,
                isReleaseFile:false
            }
            this.$post('/tra/project/file/', obj, function(res){
                if(res.code==200){
                    this.$message.success('上传成功!');
                    this.fileDialog = false;
                    this.$parent.getFile()
                }
            },true)
        },


        // 上传待审文件弹窗
        fileupload(){
            this.fileVisible= true
            this.fileName=''
            this.traProjectFileList=[]
            if(this.fileLength==0){
                var obj={
                    workFileList:this.traProjectFileList,
                    fileType:5,
                    traProjectWorkId:this.id
                }
                this.obj= obj
            }else{
                var objs = {
                    workFileList:this.traProjectFileList,
                    fileType:3,
                    traProjectWorkId:this.id
                };
                this.obj= objs
            }
            this.loading = false
        },

        handleContrSuccess(res,file){
            if(this.fileLength.length==0){
                var objs = {};
                objs.fileUrl = res.data.fileUrl;
                objs.fileName = res.data.fileName;
                this.traProjectFileList.push(objs);
            }else{
                this.fileName = res.data.fileName;
                var objs={}
                objs.fileName = res.data.fileName;
                objs.fileUrl = res.data.fileUrl;
                this.traProjectFileList.push(objs)
            }
            this.loading=false
        },

        beforeContrUpload(file){
            const isLt1G = file.size / 1024 / 1024 / 1024 < 1;
            if (!isLt1G) {
                this.$message.error('上传文件大小不能超过 1GB!');
            }
            const changdu = file.name.length<50;
            if (!changdu) {
                this.$message.error('文件名称过长,请限制在25字之内!');
            }
            return isLt1G&&changdu;
        },

        // 删除文件
        delFile(index){
            this.traProjectFileList.splice(index, 1);
        },

        // 上传稿件,待审文件
        submitFile(){
            if(this.fileLength!=0){
                if(this.traProjectFileList.fileUrl==''){
                    this.$message.error('请先上传文件');
                    return
                }
            }else{
                if(this.traProjectFileList.length==0){
                    this.$message.error('请先上传文件');
                    return
                }
            }
            this.$post('/tra/project/work/file', this.obj, function(res){
                if(res.code==200){
                    this.$message.success('上传成功!');
                    this.fileVisible = false;
                    this.obj=''
                    this.traProjectFileList=[]
                    this.$parent.projectXn()
                }
            },true)
        },

        // 项目详情
        getProInfo(){
            this.$get('/tra/project/detail?id='+this.$route.query.id,function(res){
                if (res.code == 200) {
                    this.info = res.data;
                    this.form.oldMeetingPlace= res.data.meetingPlace?res.data.meetingPlace:''
                    this.form.oldMeetingTime=res.data.meetingTime?res.data.meetingTime:''
                    this.form.projectName=res.data.projectName
                    this.editForm.finalProjectInvestment = res.data.projectInvestment
                    this.editForm.finalProjectContent = res.data.projectContent
                    this.editForm.finalProjectCraft = res.data.projectCraft
                    this.editForm.finalProjectDuration = res.data.projectDuration
                    this.editForm.originProjectContent = res.data.projectContent;
                    this.editForm.originProjectCraft = res.data.projectCraft?res.data.projectCraft:'';
                    this.editForm.originProjectDuration = res.data.projectDuration?res.data.projectDuration:'';
                    this.editForm.originProjectInvestment = res.data.projectInvestment;
                    this.editForm.originProjectPlanEndTime = res.data.projectPlanEndTime;
                    this.formbz.oldTime = res.data.projectEnsureTime;
                }
            })
        },

        // 添加工单
        openWork(){
            this.workVisible= true 
            this.form.demandType= ''
            this.form.demandDescribe=''
            this.form.newMeetingPlace= ''
            this.form.newMeetingTime =''
            this.form.traProjectId= this.$route.query.id
        },

        // 确定工单添加
        ensureWork(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    this.$post('/tra/project/demand/audit',this.form,function(res){
                        if(res.code==200){
                            this.$message.success('添加成功');
                            this.workVisible= false
                        }
                    },true)
                }
            })
        },

        // 审核动态
        openAudit(){
            this.auditVisible=true
            this.formz.traProjectId = this.$route.query.id
            this.$get('/tra/project/dynamic?traProjectId='+this.$route.query.id,function(res){
                if(res.code==200){
                    if(res.data){
                        this.formz = res.data
                    }
                }
            })
        },

        // 确定审核动态
        ensureAudit(){
            if(this.formz.id){
                this.$put('/tra/project/dynamic', this.formz,function(res){
                    if(res.code==200){
                        this.$message.success('添加成功!')
                        this.auditVisible= false;
                    }
                },true)
            }else{
                this.$post('/tra/project/dynamic', this.formz,function(res){
                    if(res.code==200){
                        this.$message.success('添加成功!')
                        this.auditVisible= false;
                    }
                },true)
            }
        },

        // 申请退款
        openRefund(){
            this.getRefundPerson()
            this.refundVisible =true
            this.refundForm.traProjectBidIds = ''
            this.refundForm.traProjectId = this.$route.query.id
        },

         // 退款人员列表
        getRefundPerson(){
        let params = { projectId: this.$route.query.id }
            this.$get('/tra/project/bid/isChoose', params,function(res){
                if(res.code==200){
                    this.personList= res.data
                }
            })
        },

        // 选择退款人员
        changePerson(e){
            var personList= this.personList;
            var money=0;
            for(var i=0;i<personList.length;i++){
                for(var j=0;j<e.length;j++){
                if(e[j]==personList[i].id){
                    money+=personList[i].finalOffer
                }
                }
            }
            this.refundForm.refundMoney= money
        },

        // 确定退款
        ensureRefund(refundForm){
            this.$refs[refundForm].validate((valid) => {
                if (valid) {
                    this.refundForm.traProjectBidIds= this.refundForm.traProjectBidIds.toString()
                    this.$post('/tra/project/refund/apply',this.refundForm,function(res){
                        if(res.code==200){
                            this.refundVisible= false
                            this.$message.success('申请成功,请等待审核')
                            this.$parent.getRefundInfo()
                        }else{
                            this.$message.error(res.msg)
                        }
                    },true)
                }
            })
        },

        openRecordVisible(id){
            this.recordVisible= true
            this.reForm.traProjectWorkFileId= id
            this.getRecordInfo()
        },

        getRecordInfo(){
            this.$get('/tra/project/work/file/record/list',this.reForm,function(res){
                if(res.code==200){
                    this.recordList= res.data.records
                }
            })
        }
    },
    mounted(){
        this.headers = {
            "Authorization": 'bearer ' + getSession('token').access_token
        }
        this.getProInfo()
    }
})
